import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-custom-progress',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './custom-progress.component.html',
  styleUrls: ['./custom-progress.component.css'] 
})
export class CustomProgressComponent {
  @Input() title: string = '';
  @Input() infoText: string = '';
  @Input() percentage: number = 0;
  @Input() footerText: string = '';
  @Input() dangerOnOverflow: boolean = false;

  get clampedWidth(): number {
    return this.percentage > 100 ? 100 : this.percentage;
  }

  get isSuccess(): boolean {
    return !this.dangerOnOverflow && this.percentage >= 100;
  }

  get isDanger(): boolean {
    return this.dangerOnOverflow && this.percentage > 100;
  }
}